type Props = {
  image: string
  location: string
  link: string
}

export const itemProps: Props[] = [
  {
    image: './Website/Photography/Home/bosnia.jpg',
    location: 'Bosnia and Herzegovina',
    link: '/bosnia-and-herzegovina',
  },
  {
    image: './Website/Photography/Home/malaysia.jpg',
    location: 'Malaysia',
    link: '',
  },
  {
    image: './Website/Photography/Home/singapore.jpg',
    location: 'Singapore',
    link: '',
  },
  {
    image: './Website/Photography/Home/qatar.jpg',
    location: 'Qatar',
    link: '',
  },
]
